import { useAuthOptional } from '../../../contexts/auth-context'
import { useLiveJourneyPings } from '../hooks/use-live-journey-pings'

function LiveJourneyPingRunner() {
  useLiveJourneyPings()
  return null
}

/**
 * Always-mounted (authenticated shell) controller that owns the provider's
 * live en-route journey pings — web cadence while foregrounded on any screen,
 * native hand-over while backgrounded. Renders nothing. See
 * {@link useLiveJourneyPings} for the lifecycle rules.
 *
 * Keyed by the signed-in user id: an account switch unmounts the previous
 * runner (its cleanup disarms the native pinger and drops the previous user's
 * journey) before the next user's mounts. Nothing runs while signed out.
 */
export function LiveJourneyPingController() {
  const auth = useAuthOptional()
  const userId = auth && !auth.isLoading ? auth.user?.userId ?? null : null
  if (!userId) return null
  return <LiveJourneyPingRunner key={userId} />
}
